import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import "./styles.css";

function AppProviders() {
  const app = (
    <ToastProvider>
      <App />
    </ToastProvider>
  );
  const isStandaloneTool = window.location.pathname === "/totp-tool" || window.location.pathname.startsWith("/totp-tool/");
  return isStandaloneTool ? app : <AuthProvider>{app}</AuthProvider>;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AppProviders />
    </BrowserRouter>
  </StrictMode>,
);
